import React, { Component } from 'react';
import "./week_dates.css"

export default class WeekDates extends Component {
	componentDidMount () {
		this.latestKnownScroll = 0,
		this.ticking = false;
		let update = () => {
			// reset the tick so we can
			// capture the next onScroll
			this.ticking = false;

			let currentScrollY = this.latestKnownScroll;

			this.dates.scrollLeft = currentScrollY;
			// read offset of DOM elements
			// and compare to the currentScrollY value
			// then apply some CSS classes
			// to the visible items
		}
		let onScroll = () => {
			this.latestKnownScroll = window["app-calendar"].scrollLeft;
			requestTick();
		}

		let requestTick = () =>  {
			if(!this.ticking) {
				requestAnimationFrame(update);
			}
			this.ticking = true;
		}

		window["app-calendar"].addEventListener("scroll", onScroll)
	}
	render() {
		let dates = [];
		for (let i = 0; i < this.props.dates.deltaDays; i++) {
			let o = this.props.dates.from.clone().add(i,"d");
			dates.push((
				<div className="date-day" key={o.format()}>
					<div>{o.format("dddd")}</div>
					<div>{o.format("DD MMMM")}</div>
				</div>
			));
		}
		return (
			<div className="dates-range" ref={(ref) => this.dates = ref}>
				{dates}
			</div>
		)
	}
}

WeekDates.propTypes = {
	moment: React.PropTypes.object
};


/** WEBPACK FOOTER **
 ** ./src/components/week_dates.js
 **/